import { TableColumnMeta } from "ds/components/Table/types";

export const TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMNS_STORAGE_KEY =
  "templateDeploymentOutputsColumnsConfig";

export enum TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMN_ID {
  NAME = "NAME",
  DESCRIPTION = "DESCRIPTION",
  VALUE = "VALUE",
  STACK = "STACK",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 2000;

export const TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMN_CONFIG: Record<
  TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMN_ID,
  TableColumnMeta
> = {
  [TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMN_ID.NAME]: {
    id: TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 180,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: false,
    canPin: true,
    canMove: true,
  },
  [TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMN_ID.DESCRIPTION]: {
    id: TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 200,
    defaultWidth: 300,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: false,
    canPin: true,
    canMove: true,
  },
  [TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMN_ID.VALUE]: {
    id: TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMN_ID.VALUE,
    title: "Value",
    minWidth: 200,
    defaultWidth: 300,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: false,
    canPin: true,
    canMove: true,
  },
  [TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMN_ID.STACK]: {
    id: TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMN_ID.STACK,
    title: "Stack",
    minWidth: 180,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: false,
    canPin: true,
    canMove: true,
  },
  [TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMN_ID.DROPDOWN]: {
    id: TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMN_ID.DROPDOWN,
    title: "Output actions",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    allowsSorting: false,
    resizable: false,
  },
};
